<!-- Contact Fundraiser -->
<div class="contact-dialog">
  <div class="c-close" [ngClass]="{'m0': variablesService.isFundraiserLeftDialog}">
    <button class="close-btn" [ngClass]="{'close-btn-isFundraiserLeft': variablesService.isFundraiserLeftDialog}" (click)="onCloseBtnClick(true, 'close')" mat-icon-button><mat-icon>close</mat-icon></button>
  </div>
  <div class="contact-container">
    <div class="contact-header" *ngIf="variablesService.isFundraiserLeftDialog">
      <div class="img-wrapper">
        <img [attr.data-src]="'/assets/images/contact-heart.png'" alt="contact heart" loading="lazy" />
      </div>
      <div class="header-content">
        <div class="sub-title">
          Before you go,
        </div>
        <div class="main-title">
          Send your good wishes to {{variablesService?.fundraiser?.campaigner?.full_name}}
        </div>
      </div>
    </div>

    <div class="c-title" *ngIf="!variablesService.isFundraiserLeftDialog">{{"Stories.donations.contact" | translatePipe | async}} {{data?.title}}</div>
    <div class="c-desc" *ngIf="!variablesService.isFundraiserLeftDialog">
      {{"Stories.donations.contactDesc1" | translatePipe | async}} <span class="text-capitalize">{{data?.title}}</span> {{"Stories.donations.contactDesc2" | translatePipe | async}}
      Don't worry, we will not share your email address with the campaigner
    </div>

    <form [formGroup]="contacForm" class="c-form" (ngSubmit)="submit()">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-sm-12 col-xs-12">
            <app-input inputType="text"
                [control]="name"
                [group]="contacForm"
                [placeHolder]="info.name.placeholder"
                [errorMessage]="info.name.error">
            </app-input>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12">
            <app-input inputType="text"
                [control]="email"
                [group]="contacForm"
                [placeHolder]="info.email.placeholder"
                [errorMessage]="info.email.error" >
            </app-input>
        </div>
      </div>
      </div>
      <mat-form-field class="input-container mt0 textarea-msg" appearance="fill">
        <textarea class="text-area" matInput [placeholder]="'Stories.donations.enterMessage' | translatePipe | async"
                  formControlName="message"
                  maxlength="1000">
        </textarea>
        <mat-hint align="end">{{message.value?.length || 0}}/1000</mat-hint>
        <mat-error *ngIf="message.invalid">{{getErrorMessage(message)}}</mat-error>
      </mat-form-field>
      <div class="captcha-container">
        <app-captcha-input [control]="captcha" type="dialog"></app-captcha-input>
      </div>
      <button type="submit" class="c-submit-btn" [disabled]="isloading" mat-raised-button>{{ 'Stories.donations.send' | translatePipe | async }}</button>
    </form>
  </div>
</div>
